import { HttpHeaders } from '@angular/common/http';

export const ErrorInterceptorSkipHeader = 'X-Skip-Error-Interceptor';

export const httpOptionsWithSkipErrorInterceptor = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    [ErrorInterceptorSkipHeader]: '',
  }),
};
